"use client";

import { Sun } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function SecureYourSession() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <section data-section-id="164" id="secure-your-session" className="dark bg-background text-foreground relative overflow-hidden py-24 md:py-[140px]">
      {}
      <svg className="pointer-events-none absolute top-8 left-8 h-32 w-32 opacity-10 md:h-48 md:w-48" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path d="M20 180 Q 40 120 80 100 T 160 40" stroke="currentColor" strokeWidth="1" fill="none" />
        <path d="M30 170 Q 60 140 70 110" stroke="currentColor" strokeWidth="1" fill="none" />
        <path d="M90 95 Q 100 80 110 70 Q 120 65 130 70" stroke="currentColor" strokeWidth="1" fill="none" />
        <circle cx="80" cy="100" r="3" fill="currentColor" />
        <circle cx="130" cy="70" r="2.5" fill="currentColor" />
      </svg>
      <svg className="pointer-events-none absolute bottom-8 right-8 h-32 w-32 opacity-10 md:h-48 md:w-48 rotate-180" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path d="M20 180 Q 40 120 80 100 T 160 40" stroke="currentColor" strokeWidth="1" fill="none" />
        <path d="M30 170 Q 60 140 70 110" stroke="currentColor" strokeWidth="1" fill="none" />
        <path d="M90 95 Q 100 80 110 70 Q 120 65 130 70" stroke="currentColor" strokeWidth="1" fill="none" />
        <circle cx="80" cy="100" r="3" fill="currentColor" />
        <circle cx="130" cy="70" r="2.5" fill="currentColor" />
      </svg>

      <div ref={ref} className={`relative mx-auto max-w-[720px] px-6 text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
        {}
        <div className="mb-8 flex justify-center">
          <Sun className="h-10 w-10 text-primary" strokeWidth={1.25} aria-hidden="true" />
        </div>

        {}
        <div className="mb-8 flex items-center justify-center gap-4">
          <span className="block h-px w-[60px] bg-primary" aria-hidden="true" />
          <span className="font-default text-xs uppercase tracking-[0.25em] text-muted-foreground">
            ¿Listo para tu look?
          </span>
          <span className="block h-px w-[60px] bg-primary" aria-hidden="true" />
        </div>

        {}
        <h2 className="font-default font-light leading-[1.1] text-foreground text-4xl md:text-5xl lg:text-[56px]" style={{
        letterSpacing: "-0.01em"
      }}>
          Asegura tu sesión para una experiencia de belleza personalizada.
        </h2>

        {}
        <p className="mx-auto mt-8 max-w-[600px] font-default text-base md:text-[17px] text-muted-foreground" style={{
        lineHeight: 1.7
      }}>
          Niki B. Makeup ofrece artistry profesional de cabello y maquillaje con cita previa. 
          Reserva tu fecha para asegurar un look pulido y listo para editorial para tu próximo proyecto.
        </p>

        {}
        <div className="mt-10 flex flex-col items-stretch justify-center gap-4 sm:flex-row sm:items-center sm:gap-4">
          <Button asChild size="lg" className="h-12 bg-primary px-8 font-default text-sm font-medium uppercase tracking-[0.15em] text-primary-foreground hover:bg-primary/90">
            <Link to="/BookingPage">Reserva Tu Sesión</Link>
          </Button>
          <Button asChild variant="outline" size="lg" className="h-12 border-foreground/40 bg-transparent px-8 font-default text-sm font-medium uppercase tracking-[0.15em] text-foreground hover:bg-foreground/5 hover:text-foreground">
            <Link to="/ContactPage">Consultar Ahora</Link>
          </Button>
        </div>

        {}
        <p className="mt-8 font-default text-xs tracking-wide text-muted-foreground">
          Disponible en Valencia y Madrid.
        </p>
      </div>
    </section>;
}